import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";
import Message from "./components/Message.js";
import PopinCta from "./components/PopinCta.js";
import SubscribeForm from "./components/SubscribeForm.js";
import Badge from "./components/Badge.js";
import Alert from "./components/Alert.js";
import Header from "./components/Header.js";
import Footer from "./components/Footer.js";
import moment from "moment/moment.js";
require("moment/locale/fr");

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');

axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;

var connexion = 0;

var timeout = 1000000;

var first_time = true;

var loading_messages = false;

var lastScrollTop = 0;

var temporaryMsgId = 0;

var message_sound = document.createElement("AUDIO");
document.body.appendChild(message_sound);
message_sound.src = "/assets/sounds/new_message.mp3";

window.isChatbotDocVisible = !document.hidden;
window.isChatbotDocFocus = document.hasFocus();

function visibilitychange(event) {
    window.isChatbotDocVisible = !document.hidden;
    if (!window.isChatbotDocVisible) {
        //console.log('not visible');
    } else {
        //console.log('is visible');
    }
    window.isChatbotDocFocus = document.hasFocus();
    if (!window.isChatbotDocFocus) {
        //console.log('not Focus');
    } else {
        //console.log('is Focus');
    }
}
document.addEventListener("visibilitychange", visibilitychange);
document.addEventListener("mozvisibilitychange", visibilitychange);
document.addEventListener("webkitvisibilitychange", visibilitychange);
document.addEventListener("msvisibilitychange", visibilitychange);
window.addEventListener("blur", visibilitychange);
window.addEventListener("focus", visibilitychange);

const App = (React.FC = ({ ...props }) => {
    //const isKeyboardOpen = useDetectKeyboardOpen();
    const [chatbotUuid, setChatbotUuid] = useState(window.chatbot_uuid);
    const [isSubscribed, setIsSubscribed] = useState(
        window.has_chatbot_conversation
    );
    const [isJustSubscribed, setIsJustSubscribed] = useState(false);
    const [isWelcomed, setIsWelcomed] = useState(false);
    const [chatbotIsOpen, setChatbotIsOpen] = useState(false);
    const [unreadMessages, setUnreadMessages] = useState(
        window.chatbot_unread_messages ?? 0
    );
    const [successMessage, setSuccessMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState([]);
    const [oldestMessageId, setOldestMessageId] = useState(null);
    const [recentMessageId, setRecentMessageId] = useState(null);
    const [isMarkAsSeen, setIsMarkAsSeen] = useState(null);
    const [hasMoreMessages, setHasMoreMessages] = useState(true);

    useEffect(() => {
        getMessages();

        console.log(props);

        window.Echo.connector.pusher.connection.bind(
            "unavailable",
            (payload) => {
                console.log("unavailable");
                setErrorMessage("bla bla bla");
                setSuccessMessage(false);
                setIsLoading(false);
            }
        );

        window.Echo.connector.pusher.connection.bind(
            "disconnected",
            (payload) => {
                console.log("disconnected");
                setErrorMessage("bla bla bla");
                setSuccessMessage(false);
                setIsLoading(false);
            }
        );

        window.Echo.connector.pusher.connection.bind("connected", (payload) => {
            console.log(new Date(), payload);
            connexion++;

            if (isSubscribed && !first_time && connexion > 1) {
                window.ensureIsConnected(timeout).then(function () {
                    updateMessages();
                });
            }

            setSuccessMessage("bla bla bla");
            setErrorMessage(false);
            setIsLoading(false);
            setTimeout(function () {
                setSuccessMessage(false);
            }, 2000);
        });
    }, []);

    useEffect(() => {
        listenToMessages();
    }, [chatbotUuid]);

    useEffect(() => {
        if (!isSubscribed) return;
        if (unreadMessages > 0) markAsSeen();
    }, [chatbotIsOpen]);

    const chatAxios = () => {
        let token = document.head.querySelector('meta[name="csrf-token"]');
        axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
        try {
            axios.defaults.headers.common["X-Socket-ID"] =
                window.Echo.socketId();
        } catch (error) {}

        return axios;
    };

    const listenToMessages = () => {
        console.log("listenToMessages");
        if (chatbotUuid !== "") {
            let chatbot_channel = window.Echo.channel("chatbot-" + chatbotUuid);
            chatbot_channel.listen(".message", (e) => {
                if (e.conversation_uuid === chatbotUuid) {
                    console.log("for Me -> ", e);
                    let message = e.message;
                    message.date = moment(message.date);
                    setMessages((old) => {
                        return [...old, e.message];
                    });

                    try {
                        //if (!chatbotIsOpen) {
                        message_sound.currentTime = 0;
                        message_sound.play();
                        //}
                    } catch (error) {}
                    setUnreadMessages(e.unread_messages);
                    sleep(50);
                    scrollToBottom();
                }
            });
        }
    };

    const handleListMessageScroll = (e) => {
        console.log("scroll");
        var st = e.currentTarget.scrollTop;

        if (
            chatbotIsOpen &&
            window.isChatbotDocVisible &&
            window.isChatbotDocFocus
        )
            markAsSeen();

        if (
            hasMoreMessages &&
            e.currentTarget.scrollTop <= 20 &&
            st < lastScrollTop
        ) {
            console.log("azaaa");
            getMessages(oldestMessageId);
        }
        lastScrollTop = st <= 0 ? 0 : st;
    };

    useEffect(() => {
        //console.log(messages);
        if (messages.length == 0) return;
        setOldestMessageId(messages[0].id);
        setRecentMessageId((old) =>
            Number.isInteger(messages[messages.length - 1].id)
                ? messages[messages.length - 1].id
                : old
        );
    }, [messages]);

    useEffect(() => {
        if (!isJustSubscribed) return;

        getMessages(null, true);
    }, [isJustSubscribed]);

    const getMessages = (oldMId = null, just_sub = false) => {
        if (!isSubscribed) return false;
        if (isLoading) return false;

        var formData = new FormData();
        if (oldMId !== null) formData.append("oldest_id", oldMId);

        first_time = false;

        setIsLoading(true);
        sleep(50);

        chatAxios()
            .post("/newchatbot/getMessages", formData)
            .then((response) => {
                //console.log(response);
                console.log(response.data);
                if (response.data.success) {
                    var messages_list = response.data.messages;

                    let scrollTop =
                        document.querySelector("#message-list").scrollTop;

                    messages_list = messages_list.map((element, index) => {
                        messages_list[index].date = moment(element.date);
                        return element;
                    });

                    if (oldMId === null) {
                        setMessages((old) => {
                            return [...old, ...messages_list];
                        });
                        sleep(50);
                        scrollToBottom();
                    } else {
                        console.log("update");
                        setMessages((old) => {
                            return [...messages_list, ...old];
                        });

                        document.querySelector("#message-list").scrollTop =
                            scrollTop + 10;
                    }

                    setHasMoreMessages(response.data.has_more);

                    if (just_sub) {
                        /*let lastElement = messages_list.pop();
                        console.log(lastElement);
                        console.log(lastElement.prompt == "start");
                        console.log(lastElement.type == "bot_prompt_answser");
                        if (
                            lastElement.prompt == "start" &&
                            lastElement.type == "bot_prompt_answser"
                        )
                            return;*/
                        chatAxios().post("/newchatbot/start");
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .then(function () {
                setIsLoading(false);
            });
    };

    const updateMessages = () => {
        if (chatbotUuid == "") return false;
        var formData = new FormData();
        if (recentMessageId !== false)
            formData.append("recent_id", recentMessageId);
        loading_messages = true;
        chatAxios()
            .post("/newchatbot/updateMessages", formData)
            .then((response) => {
                if (response.data.success) {
                    chatbot_messages_list.insertAdjacentHTML(
                        "beforeend",
                        response.data.messages
                    );
                    chatbot_messages_list.scrollTop =
                        chatbot_messages_list.scrollHeight;
                    setRecentMessageId(response.data.recent_id);
                }
            })
            .catch(function (error) {
                //console.log(error);
            })
            .then(function () {
                loading_messages = false;
            });
    };

    const addMessage = async (
        type,
        message,
        custom_message = "",
        prompt = "",
        parent_prompt = ""
    ) => {
        if (chatbotUuid == "") return false;
        if (message.trim().length == 0 || !window.isConnected) return;

        temporaryMsgId += 1;
        let temp_id = "temp_" + temporaryMsgId;

        setMessages((old) => [
            ...old,
            {
                id: temp_id,
                is_user: true,
                is_error: false,
                is_loading: true,
                message: custom_message == "" ? message : custom_message,
                type: type,
                parent_prompt: parent_prompt,
                date: moment(),
                actions: [],
            },
        ]);

        sleep(50);
        scrollToBottom();
        setMessage("");

        var formData = new FormData();
        formData.append("type", type);
        formData.append("message", message);
        formData.append("prompt", prompt);
        formData.append("parent_prompt", parent_prompt);
        formData.append("temp_id", temp_id);

        chatAxios()
            .post("/newchatbot/send", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                if (response.data.success) {
                    setMessages((old) => {
                        return old.map((element, index) => {
                            if (element.id === response.data.temp_id) {
                                old[index].id = response.data.id;
                                old[index].is_loading = false;
                            }
                            return element;
                        });
                    });
                }
            })
            .catch(function (err) {
                setMessages((old) => {
                    return old.map((element, index) => {
                        if (element.id === temp_id) {
                            old[index].is_error = true;
                            old[index].is_loading = false;
                        }
                        return element;
                    });
                });
            })
            .then(function () {});
    };

    const markAsSeen = () => {
        if (!isSubscribed) return false;
        if (isMarkAsSeen) return false;
        if (unreadMessages == 0) return false;
        setIsMarkAsSeen(true);
        chatAxios()
            .post("/newchatbot/markAsSeen")
            .then((response) => {
                //console.log(response);
                if (response.data.success) {
                    setUnreadMessages(0);
                }
            })
            .catch(function (error) {
                //console.log(error);
            })
            .then(function () {
                setIsMarkAsSeen(false);
            });
    };

    const scrollToBottom = () => {
        setTimeout(function () {
            document.querySelector("#message-list").scrollTop =
                document.querySelector("#message-list").scrollHeight;
        }, 50);
    };

    const subscribeUserHandler = (e) => {
        e.preventDefault();

        var formData = new FormData();
        formData.append("email", e.target.email.value);

        return axios
            .post("/newchatbot/subscribe", formData)
            .then(
                (response) => {
                    if (response.data.success) {
                        setIsSubscribed(true);
                        setChatbotUuid(response.data.uuid);
                        setIsJustSubscribed(true);
                    }
                },
                (error) => {
                    //console.log(error);
                }
            )
            .then(() => {
                return true;
            });
    };

    return (
        <div>
            <div className="cloe-chatbot" id="cloe-chatbot">
                <div className="cloe-chatbot-wrapper">
                    <Badge
                        chatbotIsOpen={chatbotIsOpen}
                        props={props.dataset}
                        unreadMessages={unreadMessages}
                        onClick={() => {
                            setChatbotIsOpen(true);
                            setIsWelcomed(true);
                        }}
                    />

                    <PopinCta
                        isSubscribed={isSubscribed}
                        isWelcomed={isWelcomed}
                        setIsWelcomed={setIsWelcomed}
                        props={props.dataset}
                    />

                    <div
                        className={
                            "cloe-chatbot-chatbox-window " +
                            (chatbotIsOpen ? "show" : "")
                        }
                    >
                        {isSubscribed ? (
                            <Header
                                onClick={() => {
                                    setChatbotIsOpen(!chatbotIsOpen);
                                }}
                                props={props.dataset}
                            />
                        ) : null}

                        {isSubscribed ? (
                            <React.Fragment>
                                <div className="chatbot-chatbox-messages">
                                    <div
                                        className="chatbox-messages"
                                        id="message-list"
                                        onScroll={handleListMessageScroll}
                                    >
                                        {messages.map((message, i) => {
                                            return (
                                                <Message
                                                    key={i}
                                                    message={message}
                                                    axios={axios}
                                                    actionBtnClick={(
                                                        action
                                                    ) => {
                                                        console.log(
                                                            "actionClick",
                                                            message,
                                                            action
                                                        );
                                                        addMessage(
                                                            "bot_prompt",
                                                            action.message,
                                                            action.message_print,
                                                            action.prompt,
                                                            message.prompt
                                                        );
                                                    }}
                                                />
                                            );
                                        })}
                                        <div id="message-end-ref" />
                                    </div>
                                    <Alert
                                        isLoading={isLoading}
                                        successMessage={successMessage}
                                        errorMessage={errorMessage}
                                        props={props.dataset}
                                    />
                                </div>

                                <Footer
                                    message={message}
                                    setMessage={setMessage}
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        console.log("onSubmit");
                                        addMessage("custom", message);
                                    }}
                                    onStartConversation={() => {
                                        console.log("onStartConversation");
                                        addMessage(
                                            "bot_prompt",
                                            "start",
                                            props.dataset.promptStart,
                                            "start"
                                        );
                                    }}
                                    props={props.dataset}
                                />
                            </React.Fragment>
                        ) : null}

                        {true ? (
                            <SubscribeForm
                                onClick={() => {
                                    setChatbotIsOpen(!chatbotIsOpen);
                                }}
                                chatbotIsOpen={chatbotIsOpen}
                                subscribeUserHandler={subscribeUserHandler}
                                isSubscribed={isSubscribed}
                                props={props.dataset}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
});

class NewChatbotModule {
    constructor({ target, baseUrl, ...props }) {
        this.props = props;
        this.target = target;
        this.baseUrl = baseUrl;
    }

    mount() {
        var chatbot_el = document.getElementById("cloe-chatbot");
        if (chatbot_el) {
            this.props.dataset = chatbot_el.dataset;
            createRoot(chatbot_el).render(<App {...this.props} />);
        }
    }
}

window.newchatbot = NewChatbotModule;

document.addEventListener("DOMContentLoaded", () => {
    const sim = new window.newchatbot({
        target: ".orientateur-content",
        baseUrl: "http://localhost:10001",
        logo: "/wp-content/themes/fortuny/assets/img/fortuny.svg",
        contactAs: "https://fortunyconseil.fr/contact/",
        onClose: () => {
            alert("Close your modal please");
        },
    });
    sim.mount();
});
